import * as React from "react";

import { SettingsService } from "@pro/_services";

interface PaymentHistoryState {
    url: string;
}
export class PaymentHistory extends React.Component<any, PaymentHistoryState> {
    private _abortControllers: { [key: string]: AbortController } = {};

    constructor(props) {
        super(props);
        this.state = { url: "" };
    }

    componentDidMount() {
        // Check to see if there already was an abortController, and if so, call abort on it
        if (this._abortControllers.getPaymentsHistoryUrl) {
            this._abortControllers.getPaymentsHistoryUrl.abort();
        }
        this._abortControllers.getPaymentsHistoryUrl = new AbortController();
        const signal = this._abortControllers.getPaymentsHistoryUrl.signal;

        SettingsService.getPaymentsHistoryUrl(signal).then(response => {
            this.setState({ url: response });
        });
    }

    componentWillUnmount() {
        const abortControllers = this._abortControllers;
        if (Object.keys(abortControllers).length > 0) {
            Object.keys(abortControllers).map(key => abortControllers[key].abort());
        }
    }

    render() {
        return (
            <section className="c-settings__pane">
                <h2 className="c-settings__title">payment history</h2>
                <div>
                    <iframe src={this.state.url} width="100%" height="2800" frameBorder={0} />
                </div>
            </section>
        );
    }
}
